import { render, staticRenderFns } from "./PrintConfig.vue?vue&type=template&id=2faee616&"
import script from "./PrintConfig.vue?vue&type=script&lang=js&"
export * from "./PrintConfig.vue?vue&type=script&lang=js&"
import style0 from "./PrintConfig.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports